<template>
  <ElDialog
      name="branding-colour-modal"
      :visible="show"
      v-on="$listeners"
      v-loading="loading"
      title="Brand Colour"
      append-to-body
      @open="colour = initialColour"
  >
    <VForm :onSubmit="validateForm" method="post" data-vv-scope="brand-colour-update">
      <div slot="row">
        <b>{{ $t('branding.selectColour') }}</b>
        <ElColorPicker
          class="block my-base"
          size="large"
          v-model="colour"
          data-ec="branding_colour_modal"
          data-et="colour_picker"
        />
        <b>{{ $t('functional.preview') }}</b>
        <div v-bind:style="{ 'background-color': colour }" class="brand-colour-display my-base">
          <span class="text-white font-semibold">{{ colour }}</span>
        </div>
        <VButton
            subtype="submit"
            type="cta-1"
            data-ec="branding_colour_modal"
            data-et="save_button"
            class="float-right"
            :disabled="!colour">
          <span>{{ $t('functional.save') }}</span>
        </VButton>
      </div>
    </VForm>
  </ElDialog>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';

export default {
  name: 'SwitchBrandColourModal',
  props: {
    show: Boolean,
    initialColour: {
      type: String,
      default: '#0099CE',
    },
  },
  inject: {
    $validator: '$validator',
  },
  data() {
    return {
      loading: false,
      colour: this.initialColour,
    };
  },
  components: {
    VButton,
    VForm,
  },
  methods: {
    validateForm(scope) {
      this.loading = true;
      this.$validator.validateAll(scope).then(() => this.$store.dispatch('branding/UPDATE', {
        colour: this.colour,
      }).then(() => {
        this.$emit('close');
      }).finally(() => {
        this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('branding.brandColorUpdatedMessage'), icon: 'check', type: 'success' }));
        this.loading = false;
      }));
    },
  },
};
</script>
